<script lang='ts'>
	import Template from './+template.svelte';
	import Button from '../Button.svelte';
	import { onMount } from 'svelte';
	import game from '../../game/game';
	import { currentScreen } from '../../stores';
	import ActionCaption from '../ActionCaption.svelte';
	import MainButton from '../MainButton.svelte';
	import Groznov from '../Groznov.svelte';
	import PrizesImg from '../PrizesImg.svelte';
	import Image from '../Image.svelte';
	import { isUserRegistered } from '../../utils';
	import ScrollInformer from '../ScrollInformer.svelte';

	let loaded = false;

	const start = () => {
		if (isUserRegistered()) {
			currentScreen.customization();
		} else {
			currentScreen.intro();
		}

		window.exponea.track('opora_smkt', {
			event_action: 'game_start',
		});
	};

	onMount(async () => {
		await game.load();
		loaded = true;
	});
</script>

<Template>
	<div class='logo'>
		<svg fill='none' viewBox='0 0 143 22' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M13.643 21.642c-1.226-.23-2.417-.555-3.496-1.208-2.764-1.67-4.343-4.093-4.651-7.321-.068-.714-.068-.733-.797-.733-1.113 0-2.23-.015-3.343.008-.417.007-.564-.14-.545-.555.12-2.64 1.019-4.98 2.718-6.993C5.575 2.416 8.2.974 11.353.728c4.64-.362 8.32 1.439 10.934 5.313 1.233 1.83 1.808 3.892 1.868 6.086.113 4.025-2.511 7.744-6.324 9.05-.59.2-1.203.299-1.797.465h-2.39Zm5.738-9.288c.007-2.545-2.027-4.63-4.542-4.644-2.534-.016-4.617 2.035-4.632 4.56-.015 2.59 2 4.664 4.545 4.675 2.583.011 4.617-2.009 4.625-4.588l.004-.003ZM142.776 8.351c-1.211.008-2.422.038-3.629.015-.451-.007-.564.151-.564.582.015 3.25.008 6.502.008 9.749 0 .657-.008.66-.669.664h-2.245c-.499 0-.748-.244-.748-.732v-9.56c0-.463-.224-.695-.673-.695-1.004 0-2.008-.015-3.012.008-.394.007-.541-.136-.53-.53.019-.637 0-1.275.004-1.91 0-.63.019-.649.635-.649h11.419v3.058h.004ZM68.419 11.05v7.681c0 .607-.023.626-.61.63-.86 0-1.721-.007-2.578.004-.35.004-.474-.132-.474-.483.007-4.365.007-8.734 0-13.098 0-.382.154-.503.511-.499a68.04 68.04 0 0 0 2.15 0c.32-.004.531.121.726.37 1.343 1.74 2.696 3.474 4.042 5.21.44.567.436.563.888-.01 1.353-1.734 2.71-3.463 4.06-5.196.177-.23.365-.378.673-.37.748.011 1.496.011 2.245 0 .368-.008.511.147.511.514-.004 4.35-.008 8.699 0 13.049 0 .404-.18.52-.556.513-.828-.015-1.659 0-2.486-.004-.65 0-.68-.026-.68-.668v-7.635c-.237.065-.308.234-.406.359-1.147 1.469-2.297 2.934-3.425 4.421-.271.36-.433.36-.703.008-1.166-1.514-2.35-3.013-3.53-4.52-.076-.094-.121-.226-.35-.275h-.008ZM57.978 17.897c-.124.083-.188.106-.222.147-1.44 1.903-5.384 2.31-7.831.283-1.726-1.435-2.636-3.273-2.764-5.505-.142-2.507.688-4.621 2.564-6.309 1.828-1.646 4.708-1.99 6.873-.834.493.264.88.66 1.38 1.151 0-.468.008-.796 0-1.125-.007-.283.124-.408.402-.408h2.865c.286 0 .399.144.391.42-.007.222 0 .445 0 .668v12.328c0 .638-.015.653-.631.653-.827 0-1.658-.015-2.486.007-.42.011-.575-.155-.545-.562.023-.28.004-.563.004-.91v-.004Zm.207-5.728c.023-.32-.064-.853-.218-1.374-.425-1.446-1.647-2.522-2.97-2.617-1.726-.124-3.05.59-3.726 2.096-.692 1.536-.632 3.073.222 4.534.996 1.707 3.255 2.266 4.91 1.197 1.286-.834 1.763-2.118 1.782-3.832v-.004ZM124.706 6.811c0-.442.008-.74 0-1.038-.015-.351.154-.484.493-.48.906.008 1.816.008 2.722 0 .327 0 .451.14.447.465-.011.955 0 1.91 0 2.87v10.084c0 .642-.011.65-.631.653-.813 0-1.625-.022-2.437.008-.47.019-.631-.166-.594-.612.023-.26.004-.525.004-.864-2.098 2.299-5.568 2.125-7.52.8-1.691-1.148-2.77-2.73-3.131-4.731-.568-3.141.285-5.818 2.872-7.8 1.88-1.443 4.658-1.56 6.629-.367.398.242.695.6 1.154 1.012h-.008Zm.2 5.418c.041-.713-.136-1.48-.512-2.201a3.513 3.513 0 0 0-5.628-.835c-1.5 1.522-1.613 4.358-.245 6.015 1.309 1.586 3.572 1.801 5.095.438.974-.872 1.316-2.035 1.29-3.42v.003ZM90.323 19.656c-4.147 0-7.395-3.224-7.391-7.34.003-4.01 3.36-7.34 7.406-7.32 3.93.018 7.366 3.084 7.385 7.335.018 4.142-3.249 7.322-7.403 7.322l.003.003Zm-3.654-7.241c-.045.623.101 1.302.413 1.944.647 1.325 1.692 2.122 3.177 2.164 1.324.037 2.377-.582 3.05-1.722.94-1.594.973-3.24.03-4.848-1.324-2.254-4.181-2.44-5.794-.393-.636.804-.91 1.737-.876 2.85v.005ZM103.791 13.55v4.709c-.004 1.242.128 1.095-1.094 1.102-.685.004-1.369-.011-2.057.004-.353.007-.519-.102-.519-.487.008-4.365.008-8.733 0-13.098 0-.39.169-.495.519-.491.876.011 1.752.015 2.628 0 .395-.008.53.147.527.536-.016 1.609-.008 3.22 0 4.83 0 .17-.038.347.082.588.395-.464.771-.902 1.139-1.344 1.128-1.363 2.256-2.722 3.369-4.097.293-.366.621-.532 1.102-.517 1.019.034 2.038.008 3.056.011.136 0 .316-.056.395.091.09.162-.09.25-.176.351-1.734 2.058-3.467 4.12-5.215 6.162-.241.283-.173.446.049.676 1.658 1.722 3.308 3.447 4.959 5.177.406.426.808.857 1.21 1.287.064.068.162.132.117.238-.045.106-.162.08-.252.08h-3.967c-.274 0-.421-.178-.586-.356-1.643-1.755-3.294-3.507-4.94-5.255-.076-.08-.136-.182-.339-.2l-.007.003ZM43.608 10.55c-.398 0-.797-.02-1.195.007-.433.03-.684-.129-.903-.525-1.071-1.952-3.44-2.488-5.195-1.19-.835.62-1.305 1.48-1.467 2.492-.244 1.526-.064 2.968 1.068 4.139a3.444 3.444 0 0 0 5.46-.612c.322-.54.66-.751 1.281-.706.794.057 1.59.019 2.388.011.304 0 .383.09.308.4-.707 2.806-3.388 4.966-6.298 5.09-2.109.09-4.011-.404-5.613-1.835-2.557-2.28-3.17-6.252-1.429-9.224C34.446 4.444 40.405 3.73 43.725 7.2c.786.823 1.282 1.812 1.624 2.892.113.363-.022.465-.353.457-.463-.007-.925 0-1.388 0Z'
				fill='#fff' />
		</svg>
	</div>
	<div class='cover'>
		<Image src='cover.png' />
		<ScrollInformer />
	</div>
	<div class='title'>
		{#if isUserRegistered()}
			С возвращением!
		{:else}
			Опора — в простых вещах
		{/if}
	</div>
	<div class='text'>
		{#if isUserRegistered()}
			Теперь вы можете поставить рекорд, занять первые места в рейтинге и выиграть проектор, телефон, наушники или умные
			часы. Чтобы участвовать — нужно будет оставить свой номер в конце игры.
			<br>
			<br>
			У вас есть три попытки. Вы можете играть, пока они не закончатся. 
			<br>
			<br>
			А ещё в игре появились волшебные предметы: орешки с варёной сгущёнкой от Самоката дают 300 очков, а банка нашего
			цветочного мёда — дополнительную попытку.
		{:else}
			Смена сезона может даваться непросто: пару дней назад вовсю светило солнце, а сейчас в окошко стучится дождь.
			<br>
			<br>
			Чтобы приятно провести осень и почувствовать себя бодро, попробуйте найти опору в простых вещах. Например, в
			танцах,
			которыми давно хотели заняться, неспешных завтраках по необычным рецептам, обедах с друзьями и классных поездках. 
			<br>
			<br>
			Но если вы ещё не знаете, где найти ту самую опору, то сыграйте в нашу игру — она подскажет интересный вариант. А
			ещё вы сможете весело провести время и получить призы.
		{/if}
	</div>
	<PrizesImg />
	{#if loaded}
		<MainButton click='{start}'>
			{#if isUserRegistered()}
				Играть
			{:else}
				Начать игру
			{/if}
		</MainButton>
	{:else}
		<Button disabled>Загрузка</Button>
	{/if}
	<ActionCaption />
	<Groznov />
</Template>

<style lang='scss'>
  .logo {
    width: 182px;
    height: 52px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 72, 111, 1);
    border-radius: 43px;

    svg {
      width: 142px;
      height: 21px;
    }
  }

  .cover {
    margin-top: -35px;
    margin-bottom: -30px;
    position: relative;
    display: flex;
    justify-content: center;

    @include breakpoint-up($tablet) {
      margin-top: -15px;
    }

    > :global(picture img) {
      width: 507px;
      height: auto;
      aspect-ratio: 1334 / 1352;

      @include breakpoint-up($tablet) {
        width: 100%;
      }
    }
  }

  .title {
    margin-bottom: 24px;
    font-size: 26px;
    font-weight: 700;
    line-height: 32px;
  }

  .text {
    margin-bottom: 24px;
    font-size: 20px;
    line-height: 25px;
  }
</style>
